import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import type { MonitoringMetricsResponse, MonitoringHealthResponse } from '@/types/api'

/**
 * MetricsSummary を取得するフック
 * 提案採択率・サマリー品質・エラー率等を返す
 */
export function useMonitoringMetrics(periodDays: number = 7) {
  return useQuery<MonitoringMetricsResponse>({
    queryKey: ['monitoring', 'metrics', periodDays],
    queryFn: () => getApiClient().getMonitoringMetrics(periodDays),
    // 1分ごとに更新
    staleTime: 60 * 1000,
  })
}

/**
 * Heartbeat 稼働状況を取得するフック
 */
export function useMonitoringHealth() {
  return useQuery<MonitoringHealthResponse>({
    queryKey: ['monitoring', 'health'],
    queryFn: () => getApiClient().getMonitoringHealth(),
    // 30秒ごとに更新（Heartbeat は頻繁に確認）
    staleTime: 30 * 1000,
    refetchInterval: 30 * 1000,
  })
}
